export const plausible =
  window.plausible ||
  function () {
    ' ';
  };
